module.exports = __webpack_public_path__ + "static/flags/HM-40612628a8083c5e81b803ae0cc3511d.gif";